<template>
  <div>
    <section class="section section-shaped section-lg my-0">
      <div class="shape shape-style-1 bg-gradient-default">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container pt-lg-md">
        <div class="row justify-content-center">
          <div class="col-lg-5">
          </div>
        </div>
      </div>
    </section>
    <section class="section section-lg">
      <div class="container">
        <small class="text-uppercase text-muted lead">Política de privacidade</small>
        <br>
        <br>
        <p>
          É política do Codealot respeitar a sua privacidade em relação a qualquer informação sua que possamos coletar no site Codealot, e outros sites que possuímos e operamos.
        </p>
        
        <p>
          Solicitamos informações pessoais apenas quando realmente precisamos delas para lhe fornecer um serviço. Fazemo-lo por meios justos e legais, com o seu conhecimento e consentimento. Também informamos por que estamos coletando e como será usado.
        </p>

        <p>
          Apenas retemos as informações coletadas pelo tempo necessário para fornecer o serviço solucitado. Quando armazenamos dados, protegemos dentro de meios comercialmente aceitáveis para evitar perdas e roubos, bem como acesso, divulgação, cópia, uso ou modificação não autorizados.      
        </p>

        <p>
          O compartilhamento de seus dados com empresas parceiras só acontece mediante sua autorização, ou por requisição sua. Ao completar algum teste seu resultado e habilidades podem ser compartilhados, mas seus dados como nome e contato
          só são compartilhados após sua confirmação. Tendo sua autorização, compartilhamos com a empresa parceira todos os seus dados de contato. Não compartilhamos informações de identificação pessoal sem sua autorização publicamente ou com terceiros, exceto quando exigido por lei.
        </p>

        <p>
          O nosso site pode ter links para sites externos que não são operados por nós. Esteja ciente de que não temos controle sobre o conteúdo e práticas desses sites e não podemos aceitar responsabilidade por suas respectivas políticas de privacidade.
        </p>

        <p>
          O uso continuado de nosso site será considerado como aceitação de nossas práticas em torno de privacidade e informações pessoais. Se você tiver alguma dúvida sobre como lidamos com dados do usuário e informações pessoais, entre em contacto connosco.
        </p>

        <small class="text-uppercase text-muted lead">Política de cookies</small>
        <br>
        <br>
        <p>
          O que são cookies?
        </p>
        <p>
          Como é prática comum em quase todos os sites profissionais, este site usa cookies, que são pequenos arquivos baixados no seu computador, para melhorar sua experiência. Esta página descreve quais informações eles coletam, como as usamos e por que às vezes precisamos armazenar esses cookies. Também compartilharemos como você pode impedir que esses cookies sejam armazenados, no entanto, isso pode fazer o downgrade ou 'quebrar' certos elementos da funcionalidade do site.
        </p>

        <p>
          Como Codealot usa cookies?
        </p>
        <p>
          Utilizamos cookies por vários motivos, detalhados abaixo. Infelizmente, na maioria dos casos, não existem opções padrão do setor para desativar os cookies sem desativar completamente a funcionalidade e os recursos que eles adicionam a este site. É recomendável que você deixe todos os cookies se não tiver certeza se precisa ou não deles, caso sejam usados para fornecer um serviço que você usa.
        </p>

        <p>
          Desativar cookies
        </p>
        <p>
          Você pode impedir a configuração de cookies ajustando as configurações do seu navegador (consulte a Ajuda do navegador para saber como fazer isso). Esteja ciente de que a desativação de cookies afetará a funcionalidade deste e de muitos outros sites que você visita. A desativação de cookies geralmente resultará na desativação de determinadas funcionalidades e recursos deste site. Portanto, é recomendável que você não desative os cookies.
        </p>

        <p>
          Cookies que definimos
        </p>
        <ul>

          <li>Cookies relacionados à conta</li>
        <br>
          Se você criar uma conta connosco, usaremos cookies para o gerenciamento do processo de inscrição e administração geral. Esses cookies geralmente serão excluídos quando você sair do sistema, porém, em alguns casos, eles poderão permanecer posteriormente para lembrar as preferências do seu site ao sair.
        <br>
        <br>

          <li>Cookies relacionados ao login</li>
        <br>
          Utilizamos cookies quando você está logado, para que possamos lembrar dessa ação. Isso evita que você precise fazer login sempre que visitar uma nova página. Esses cookies são normalmente removidos ou limpos quando você efetua logout para garantir que você possa acessar apenas a recursos e áreas restritas ao efetuar login.
        <br>
        <br>

          <li>Cookies relacionados a boletins por e-mail</li>
        <br>
        Este site oferece serviços de assinatura de boletim informativo ou e-mail e os cookies podem ser usados para lembrar se você já está registrado e se deve mostrar determinadas notificações válidas apenas para usuários inscritos / não inscritos.
        <br>
        <br>

          <li>Pedidos processando cookies relacionados</li>
        <br>
        Este site oferece facilidades de contexto e cookies são essenciais para garantir que informações sejam lembradas entre as páginas, para que possamos processá-las adequadamente.
        <br>
        <br>

          <li>Cookies relacionados a formulários</li>
        <br>
        Quando você envia dados por meio de um formulário como os encontrados nas páginas de contacto ou nos formulários de comentários, os cookies podem ser configurados para lembrar os detalhes do usuário para correspondência futura.
        <br>
        <br>

          <li>Cookies de preferências do site</li>
        <br>
        Para proporcionar uma ótima experiência neste site, fornecemos a funcionalidade para definir suas preferências de como esse site é executado quando você o usa. Para lembrar suas preferências, precisamos definir cookies para que essas informações possam ser chamadas sempre que você interagir com uma página for afetada por suas preferências.
        <br>
        <br>
        </ul>

        <small class="text-uppercase text-muted lead">Cookies de terceiros</small>
        <br>
        <br>
        Em alguns casos especiais, também usamos cookies fornecidos por terceiros confiáveis. A seção a seguir detalha quais cookies de terceiros você pode encontrar através deste site.
        <br>
        <br>

        <ul>

          <li>Este site usa o Google Analytics, que é uma das soluções de análise mais difundidas e confiáveis da Web, para nos ajudar a entender como você usa o site e como podemos melhorar sua experiência. Esses cookies podem rastrear itens como quanto tempo você gasta no site e as páginas visitadas, para que possamos continuar produzindo conteúdo atraente.</li>
        <br>
        Para mais informações sobre cookies do Google Analytics, consulte a página oficial do Google Analytics.
        <br>
        <br>
          <li> As análises de terceiros são usadas para rastrear e medir o uso deste site, para que possamos continuar produzindo conteúdo atrativo. Esses cookies podem rastrear itens como o tempo que você passa no site ou as páginas visitadas, o que nos ajuda a entender como podemos melhorar o site para você.</li>
          <li> Periodicamente, testamos novos recursos e fazemos alterações subtis na maneira como o site se apresenta. Quando ainda estamos testando novos recursos, esses cookies podemser usados para garantir que você receba uma experiência consistente enquanto estiver no site, enquanto entendemos quais otimizações os nossos usuários mais apreciam.</li>
          <li> À medida que conseguimos novos usuários, é importante entendermos as estatísticas sobre quantos visitantes de nosso site realmente usam e, portanto, esse é o tipo de dados que esses cookies rastrearão. Isso é importante para você, pois significa que podemos fazer previsões de negócios com precisão que nos permitem analizar nossos custos de publicidade e produtos para garantir o melhor serviço possível.</li>
          <li>O serviço Google AdSense que usamos para veicular publicidade usa um cookie DoubleClick para veicular anúncios mais relevantes em toda a Web e limitar o número de vezes que um determinado anúncio é exibido para você.</li>
        <br>
        Para mais informações sobre o Google AdSense, consulte as FAQs oficiais sobre privacidade do Google AdSense.
        <br>
        <br>
        </ul>

        <small class="text-uppercase text-muted lead">Condiderações finais</small>
        <br>
        <br>
        <p>
          Agradecemos a preferência e esperamos que tudo esteja claro. Em caso de dúvidas entrar em contato em contact@codealot.academy.
        </p>
        <p>
        Esta política é efetiva a partir de <b>Setembro/2020</b>.
        </p>


        


      </div>
    </section>
    

    <section class="section section-lg pt-lg-0">  
        <div class="container shape-container d-flex">
          <div class="col px-0">
            <div class="row justify-content-center text-center ">
              <div class="col-lg-6">
                <router-link to="/quiz">
                  <base-button type="success" size="lg" class="align-center">
                  <div class="px-5">
                    <i style="color: white" class="fa fa-check-circle"></i>
                    <span class="btn-inner--text">Faça o teste</span>
                  </div>
                  </base-button >
                </router-link>

                <p class="lead  text">
                  Você tem 3 tentativas pra passar: faça agora pra ver como se sai!
                </p>
                
              </div>
            </div>
          </div>
        </div>
      </section>

    
  </div>
</template>

<script>
export default {};
</script>
